import ScanAuditLog from './ScanAuditLog.container';

export default ScanAuditLog;
